import React from 'react';
import styled from "styled-components";
import InkassierLogo from "./icons/InkassierLogo";
import InvonedLogo from "./icons/InvonedLogo";
const StyledInvoned = styled(InvonedLogo) `
    width: 260px;
    height: 123px;
    margin-bottom: 30px;
    margin-left: -15px;
  
  @media only screen and (min-width: 576px) {
    position: absolute;
    top: 0;
    left: 0;
  }

    @media only screen and (min-width: 1200px) {
      width: 466px;
      height: auto;
    }
`;
const StyledInkassier = styled(InkassierLogo) `
  position: relative;
  display: block;
  width: 236px;
  height: 67px;
  margin: 20px auto 30px auto;

  @media only screen and (min-width: 1200px) {
    position: absolute;
    top: 70px;
    left: 70px;
    width: 293px;
    height: 84px;
    transform: none;
  }
`;
const PaymentLogo = ({ appTheme }) => {
    const getLogo = (appTheme) => {
        if (appTheme === "invoned") {
            return (React.createElement(StyledInvoned, null));
        }
        if (appTheme === "inkassier") {
            return (React.createElement(StyledInkassier, null));
        }
    };
    return (React.createElement(React.Fragment, null, getLogo(appTheme)));
};
export default PaymentLogo;
